import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    email: yup.string().email('Enter a valid email').required('Email is required'),
    phoneNumber: yup
        .string()
        .min(10, 'Phone number should contain 10 characters length')
        .required('Phone number is required'),
    password: yup.string().required('Password is required'),
    confirmPassword: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('password')], "Password doesn't match"),
});
